var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirebase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00852 28.3061L12.0862 2.17509C12.2272 1.28392 13.4226 1.07338 13.8445 1.87002L18.2273 10.0728L8.00852 28.3061ZM37.125 34.375L33.1083 10.5884C33.0792 10.4184 33.0041 10.2595 32.8911 10.1291C32.7782 9.99874 32.6317 9.90174 32.4676 9.84862C32.3035 9.79551 32.128 9.78832 31.96 9.82782C31.7921 9.86733 31.6382 9.95203 31.515 10.0728L6.875 34.375L20.57 42.2735C20.9903 42.504 21.4618 42.6248 21.9411 42.6248C22.4204 42.6248 22.892 42.504 23.3123 42.2735L37.125 34.375ZM25.9841 13.6581L22.8439 7.68197C22.7658 7.52845 22.6468 7.39953 22.5 7.30948C22.3531 7.21943 22.1843 7.17177 22.012 7.17177C21.8398 7.17177 21.6709 7.21943 21.5241 7.30948C21.3773 7.39953 21.2582 7.52845 21.1802 7.68197L7.37602 32.2902L25.9841 13.6581Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirebase);
export default __webpack_public_path__ + "static/media/firebase.b7c0e9e68b50609d43dfa84ba07918cd.svg";
export { ForwardRef as ReactComponent };